import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import strings from '../../../Globalization';
import DigitalGraph from '../../../components/common/DigitalGraph';
import LEDChart from '../../../components/common/LEDChart';
import consts from '../../../consts';
import { useCycleInfo } from '../../../contexts/CycleInfo/Context';

const FinalRinse = ({ property, propertyName }) => {
	const { data: cycle } = useCycleInfo();
	const data = cycle.ChartDetail[property];
	const isEnspire = cycle.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;

	return (
		<Grid container>
			<Grid size={12}>
				<Card>
					<CardContent sx={{ padding: 4 }}>
						<Grid container>
							{data.FinalRinse.Conductivity.WaterConduct > 0 ? (
								<Grid size={12} paddingTop={2}>
									<Box
										size={12}
										display={'flex'}
										flexDirection={'column'}
										gap={2}
										sx={{
											borderTop: (theme) => `1px solid ${theme.palette.divider}`,
											borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
											padding: (theme) => theme.spacing(2, 1)
										}}
									>
										<Typography variant="subtitle1">
											{strings[propertyName]}
											{data.FinalRinse.ThermalRinseA0 === 'None'
												? ''
												: '- ' +
												  (isEnspire ? strings.FilteredWater : data.FinalRinse.ThermalRinseA0)}
										</Typography>
									</Box>

									<Box>
										<Grid container p={2}>
											<Grid size={{xs: 12, md: 5}} display={'flex'} flexDirection={'column'} alignItems={'center'}>
												<Typography gutterBottom fontWeight={'bold'}>
													{strings.Conductivity}
												</Typography>
												<Typography gutterBottom variant="body2">
													{data.FinalRinse.Conductivity.Unit}
												</Typography>
												<LEDChart
													
													title={strings.Conductivity}
													seriesName={data.FinalRinse.Conductivity.Unit}
													upperLimit={
														data.FinalRinse.Conductivity.WaterConduct >
														data.FinalRinse.Conductivity.MaxAllowedConduct
															? data.FinalRinse.Conductivity.WaterConduct + 10
															: data.FinalRinse.Conductivity.MaxAllowedConduct + 10
													}
													middleLimit={data.FinalRinse.Conductivity.MaxAllowedConduct}
													value={data.FinalRinse.Conductivity.WaterConduct}
													unit={data.FinalRinse.Conductivity.Unit}
												/>

											</Grid>
											<Grid size="auto" >
												<Divider orientation='vertical' />
											</Grid>		
											<Grid size={{xs: 12, md: 5}}>
												<Typography textAlign={'center'}>
													{strings.FillingPortPure} {data.FinalRinse.RinsePure.WaterPort}
												</Typography>
												<DigitalGraph
													title={strings.SetTime}
													value={data.FinalRinse.RinsePure.SetTime}
												/>
												<DigitalGraph
													title={strings.ActualTime}
													value={data.FinalRinse.RinsePure.ActualTime}
												/>
											</Grid>
										</Grid>
									</Box>
								</Grid>
							) : (
								<Grid size={12} paddingTop={2}>
									<Box
										item
										size={12}
										display={'flex'}
										flexDirection={'column'}
										gap={2}
										sx={{
											borderTop: (theme) => `1px solid ${theme.palette.divider}`,
											borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
											padding: (theme) => theme.spacing(1)
										}}
									>
										<Typography variant="subtitle1">{strings[propertyName]}</Typography>
									</Box>

									<Box p={1}>
										<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
											{strings.FillingPortPure}{' '}
											{isEnspire &&
											data.FinalRinse.RinsePure.WaterPort === consts.WasterPort.FilteredWater
												? strings.FilteredWater
												: data.FinalRinse.RinsePure.WaterPort}
										</Typography>
										<DigitalGraph title={strings.SetTime} value={data.FinalRinse.RinsePure.SetTime} />
										<DigitalGraph
											title={strings.ActualTime}
											value={data.FinalRinse.RinsePure.ActualTime}
										/>
									</Box>
								</Grid>
							)}
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default memo(FinalRinse);
